import { atom } from "recoil";
import { persistAtom } from "./persistAtom";

const userAtom = atom({
  key: "user",
  default: null,
});

export default userAtom;
